import { serealizeAEMCookieCollection } from 'utils/cookie.helper';
import { TBasketItem } from '../types/basket-item.type';

export const serealizeBasket = serealizeAEMCookieCollection(
  (item: TBasketItem) => `${item.code}:${item.quantity}`
);
